import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref, watch} from 'vue';
import AuthClientFactory from '@/app/shared/infrastructure/http/AuthClientFactory';
import router from '@/router';
import rules from '@/app/shared/domain/data/rules';
import AuthTemplate from '../templates/AuthTemplate.vue';
import notificationRepository from '@/app/shared/infrastructure/persistence/notification-repository';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePasswordView',
  setup(__props) {

const client = (new AuthClientFactory()).factory();
const valid = ref(false);
let loading = ref(false);

const code = ref('');
const pass = ref('');
const confirm = ref('');
const confirmRule = v => v === pass.value || 'As senha devem ser iguais.';

watch(pass, () => {
    confirm.value = '';
});

const submit = () => {
    if (valid.value === true) {
        loading.value = true;

        client.post('/api/auth/create-password', {
            code: code.value,
            password: pass.value,
            confirm_password: confirm.value,
        }).then(response => {

            router.push('/login');
        }).catch(error => {
            if (error.response?.status === 404) {
                notificationRepository().insert({
                    id: Date.now().toString(),
                    type: 'warning',
                    message: 'Código inválido',
                });
            } else if (error.response?.status === 401) {
                notificationRepository().insert({
                    id: Date.now().toString(),
                    type: 'warning',
                    message: 'Senha não permitida',
                });
            } else if (error.response?.status === 500) {
                notificationRepository().insert({
                    id: Date.now().toString(),
                    type: 'error',
                    message: 'Desculpe, tivemos um erro interno. Tente mais tarde.'
                });
                console.error('create password error 500', error);
            } else {
                notificationRepository().insert({
                    id: Date.now().toString(),
                    type: 'error',
                    message: 'Desculpe, tivemos um erro inesperado. Tente mais tarde',
                });
                console.error('create password error', error);
            }
        }).finally(() => loading.value = false);
    }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(AuthTemplate, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, {
        onSubmit: _withModifiers(submit, ["prevent"]),
        modelValue: valid.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((valid).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "my-4" }, {
                default: _withCtx(() => [
                  _createTextVNode("Crie uma nova senha")
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_subtitle, { class: "my-4" }, {
                default: _withCtx(() => [
                  _createTextVNode("O seu código foi enviado para o e-mail")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                class: "mb-3 centered-input",
                label: "Código",
                rules: [_unref(rules).required],
                modelValue: code.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((code).value = $event))
              }, null, 8, ["rules", "modelValue"]),
              _createVNode(_component_v_text_field, {
                class: "mb-3 centered-input",
                label: "Senha",
                rules: [_unref(rules).required],
                modelValue: pass.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pass).value = $event)),
                type: "password"
              }, null, 8, ["rules", "modelValue"]),
              _createVNode(_component_v_text_field, {
                class: "mb-3 centered-input",
                label: "Confime a senha",
                rules: [_unref(rules).required, confirmRule],
                modelValue: confirm.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirm).value = $event)),
                type: "password"
              }, null, 8, ["rules", "modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                loading: _unref(loading),
                type: "submit",
                color: "info",
                variant: "flat",
                size: "large",
                block: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Criar")
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit", "modelValue"])
    ]),
    _: 1
  }))
}
}

})